import { PictureProps } from "@smile2impress/components/relaunch";
import {
    ElementResponsiveImageProps,
    STRAPI_WEBSITE_API_URL,
} from "api/cms-website";

import { getDesktopImageUrl, getMobileImageUrl } from "utils/imageUrl";

export function mapImage(
    image: ElementResponsiveImageProps | undefined
): PictureProps {
    const mobileUrl = getMobileImageUrl(image, STRAPI_WEBSITE_API_URL);
    const desktopUrl = getDesktopImageUrl(image, STRAPI_WEBSITE_API_URL);

    return {
        defaultSrc: mobileUrl || desktopUrl,
        images: [
            {
                jpeg: mobileUrl,
                webp: desktopUrl,
            },
        ],
    };
}
